import React from 'react'
import ReactDOM from 'react-dom'
import createSagaMiddleware from 'redux-saga'
import { addLocaleData, IntlProvider } from 'react-intl'
import { Provider } from 'react-redux'
import momentInit from 'lib/momentInit'
import en from 'react-intl/locale-data/en'
import pl from 'react-intl/locale-data/pl'
import de from 'react-intl/locale-data/de'
import Bus from 'lib/Bus'
import onError from 'lib/saga/onError'
import createStore from 'reports/monthlyEvaluation/store'
import { setToken } from 'reports/monthlyEvaluation/actions'
import rootSaga from 'reports/monthlyEvaluation/saga'
import keepAlive from 'lib/saga/keepAlive'
import MonthlyEvaluationReport from 'reports/monthlyEvaluation/MonthlyEvaluationReport'

const { plant, timezone, locale, messages } = window

momentInit()
addLocaleData([...en, ...pl, ...de])

const initialState = { config: { locale, timezone }, plant: { name: plant } }
const sagaMiddleware = createSagaMiddleware({ onError })
let store = createStore(initialState, [sagaMiddleware])
let saga

Bus.on('page:load', () => {
  const node = document.getElementById('monthly-evaluation-report')

  if (node) {
    store.dispatch(setToken(node.dataset.token))
    saga = keepAlive(rootSaga, sagaMiddleware)

    ReactDOM.render(
      <IntlProvider locale={locale} messages={messages}>
        <Provider store={store}>
          <MonthlyEvaluationReport />
        </Provider>
      </IntlProvider>,
      node
    )
  }
})

Bus.on('page:exit', () => {
  if (saga) {
    saga.cancel()
  }
})
